import { cityDetail } from "../util/mainOption"
import request from "../util/request"

// 交易分类排行
export function transTypeAmount (params, deptId = "") {
  return request({
    method: "post",
    url: "/api/transTypeAmount",
    params,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}
// 交易分类占比
export function transTypeRate (params, deptId = "") {
  return request({
    method: "post",
    url: "/api/transTypeRate",
    params,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}
// 近7月交易额走势
export function amountMon (params, deptId = "") {
  return request({
    method: "post",
    url: "/api/amountMon",
    params,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}
// 各指标数据统计
export function transIndicator (params, deptId = "") {
  return request({
    method: "post",
    url: "/api/transIndicator",
    params,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}
// 各组织机构排行
export function tansDeptOrder (params, deptId = "") {
  return request({
    method: "post",
    url: "/api/tansDeptOrder",
    params,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}
// 交易实时数据
export function transData (params, deptId = "") {
  return request({
    method: "post",
    url: "/api/transData",
    params,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}
// 获取乡镇列表
export function getTownList (data, deptId = "") {
  return request({
    method: "post",
    url: "/api/townList",
    params: data,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}
// 获取乡镇列表
export function transIndicator2 (params, deptId = "") {
  return request({
    method: "post",
    url: "/api/transIndicator2",
    params,
    headers: {
      deptId: deptId ? deptId : cityDetail.deptId
    }
  })
}